import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  REAL_ESTATE = 'Real Estate',
  LUXURY_HOMES = 'Luxury Homes',
  COMMERCIAL = 'Commercial',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['real-estate'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['real-estate/luxury-homes'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['real-estate/commercial'] } }
    ]
  }
};

const LUXURY_HOMES = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['real-estate/luxury-homes'] } }]
  }
};

const COMMERCIAL = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['real-estate/commercial'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: ['real-estate', 'real-estate/luxury-homes', 'real-estate/commercial']
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'real-estate' } }, { prefix: { key: 'DJEThing', value: 'real-estate/' } }],
    not: []
  }
};

export { MAIN, SECTION_ENUM, LUXURY_HOMES, COMMERCIAL, RELATED_OPINION, VIDEO };
